import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
    },
    component: () => {
      if (sessionStorage.getItem("userr") == 0) {
        return import('./views/dashboards/default');
      } else if (sessionStorage.getItem("userr") == 1) {
        return import('./views/reporting/supplier-reporting');
      }else if(sessionStorage.getItem("userr") == 2){
        return import('./views/dashboards/admin');
      }
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )

        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },
  
  {
    path: '/promotions/list',
    name: 'Liste Des Offres',
    meta: { authRequired: true },
    component: () => import('./views/promotions/promotions-list')
  },

  {
    path: '/promotions/grouped-list',
    name: 'Liste Des Offres',
    meta: { authRequired: true },
    component: () => import('./views/promotions/groupedpromotions-list')
  },

  {
    path: '/promotions/grouped-list-lgp',
    name: 'LGP Negoce',
    meta: { authRequired: true },
    component: () => import('./views/promotions/groupedpromotions-list-lgp')
  },

  {
    path: '/suppliers/list',
    name: 'Liste Des Fournisseurs',
    meta: { authRequired: true },
    component: () => import('./views/suppliers/suppliers-list')
  },

  {
    path: '/providers/list',
    name: 'Liste Des Prestataires',
    meta: { authRequired: true },
    component: () => import('./views/suppliers/providers-list')
  },

  {
    path: '/suppliers/catalog',
    name: 'Catalogue Fournisseur',
    props(route) {
      return {  supplierId: (Number)(route.query.supplierId), isCashPaymentMandetory: (Number)(route.query.isCashPaymentMandetory) }
    },
    meta: { authRequired: true },
    component: () => import('./views/suppliers/catalog')
  },

  {
    path: '/exchanges/list',
    name: 'Annonces d échanges d articles',
    meta: { authRequired: true },
    component: () => import('./views/exchanges/exchanges-list')
  },

  {
    path: '/directory',
    name: 'Annuaire',
    meta: { authRequired: true },
    component: () => import('./views/directory/directory-list')
  },

  {
    path: '/news',
    name: 'Neauvotés',
    meta: { authRequired: true },
    component: () => import('./views/news/news-list')
  },

  {
    path: '/pages/404',
    name: 'Error-404',
    meta: { authRequired: true },
    component: () => import('./views/utility/404')
  },
  {
    path: '/pages/500',
    name: 'Error-500',
    meta: { authRequired: true },
    component: () => import('./views/utility/500')
  },
  {
    path: '/orders/list',
    name: 'Liste des Commandes',
    meta: { authRequired: true },
    props(route) {
      return {  orderId: (Number) (route.query.orderId) }
    },
    component: () => import('./views/orders/orders-list')
  },

  {
    path: '/invoices/list',
    name: 'Liste des Factures',
    meta: { authRequired: true },
    component: () => import('./views/invoices/invoicesList')
  },

  //Local Invoice
  {
    path: '/local-invoices/list',
    name: 'Liste des Commandes',
    meta: { authRequired: true },
    props(route) {
      return {  orderId: (Number) (route.query.orderId) }
    },
    component: () => import('./views/local-invoices/local-invoices-list')
  },

  {
    path: '/local-invoices/get',
    name: 'Local Invoice',
    props(route) {
      return {  localInvoiceId: (Number) (route.query.localInvoiceId)}
    },
    meta: { authRequired: true },
    component: () => import('./views/local-invoices/local-invoice')
  },
 
   // Order,
   {
    path: '/orders/order',
    name: 'Order',
    props(route) {
      return {  orderId: (Number) (route.query.orderId),  showTransfer: (Boolean) (route.query.showTransfer), showCashTotal: (Boolean) (route.query.showCashTotal)}
    },
    meta: { authRequired: true },
    component: () => import('./views/orders/order')
  },
   {
    path: '/newLocalInvoice',
    name: 'NewLocalInvoice',
    props(route) {
      return {  localInvoiceId: (Number) (route.query.localInvoiceId) ,  showTransfer: (Boolean) (route.query.showTransfer)}
    },
    meta: { authRequired: true },
    component: () => import('./views/local-invoices/new-local-invoice')
  }, 
  {
    path: '/reporting',
    name: 'Rapports & Stats',
    meta: { authRequired: true },
    component: () => import('./views/reporting/reporting')
  },
  {
    path: '/supplierpromotions',
    name: "supplierpromotions",
    meta: { authRequired: true },
    props(route) {
      return {activeTab: (Number) (route.query.activeTab)  }
    },
    component: () => import('./views/promotions/supplier-promotions')
  },

  {
    path: '/promotions/new',
    name: "Nouvelle Offre",
    meta: { authRequired: true },
    component: () => import('./views/promotions/new-promotion'),
    props(route) {
      return {  promotionId: (Number)(route.query.promotionId) , suppliersOfferType: (Number)(route.query.suppliersOfferType) }
    },
  },
  {
    path: '/profil',
    name: 'Gestion de Profile',
    meta: { authRequired: true },
    component: () => import('./views/account/profil')
  },
  {
    path: '/search',
    name: 'Recherche',
    meta: { authRequired: true },
    props(route) {
      return {  keyword: route.query.keyword}
    },
    component: () => import('./views/dashboards/search-page')
  },
  {
    path: '/',
    name: 'Dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/default')
  },
  {
    path: '/items',
    name: 'Add Items',
    meta: { authRequired: true },
    component: () => import('./views/stock/addNewItems')
  },

  {
    path: '/suppliernews',
    name: 'Suppliers News',
    meta: { authRequired: true },
    component: () => import('./views/utility/maintenance')
  },

  {
    path: '/admin',
    name: 'Admin Dashboard',
    meta: { authRequired: true },
    component: () => import('./views/dashboards/admin')
  },

  {
    path: '/listOfProducts',
    name: 'Admin List of Products',
    meta: { authRequired: true },
    component: () => import('./views/admin/listOfProducts')
  },

  {
    path: '/listOfOrders',
    name: 'Admin List of Orders',
    meta: { authRequired: true },
    component: () => import('./views/orders/orders-list')
  },

  {
    path: '/listOfUsers',
    name: 'Admin List of Clients',
    meta: { authRequired: true },
    component: () => import('./views/admin/listOfUsers')
  },

  {
    path: '/banners',
    name: 'Admin Banners',
    meta: { authRequired: true },
    component: () => import('./views/admin/banners')
  },

  {
    path: '/merchandising',
    name: 'Merchandising',
    meta: { authRequired: true },
    component: () => import('./views/merchandising/merchandising')
  },

  {
    path: '/newclaim',
    name: 'Reclamations',
    meta: { authRequired: true },
    component: () => import('./views/claim/newclaim')
  },
  {
    path: '/payment',
    name: 'Paiement',
    meta: { authRequired: true },
    component: () => import('./views/payment/payment')
  },


  {
    path: '/payment/success',
    name: 'Paiement Success',
    meta: { authRequired: true },
    component: () => import('./views/payment/status/payment-success')
  },

  {
    path: '/payment/fail',
    name: 'Paiement Echoué',
    meta: { authRequired: true },
    component: () => import('./views/payment/status/payment-fail')
  },

  {
    path: '/messages',
    name: 'Messages',
    meta: { authRequired: true },
    component: () => import('./views/messages/messages')
  },


]
